import classNames from 'classnames';
import React from 'react';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
// @ts-ignore
import { Callout } from '@bingads-webui-react/callout';
// @ts-ignore
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// @ts-ignore
import { miniCalloutStyle, calloutContentStyle } from './mini-callout-styles';
import { TargetComponent } from '../types';

interface ICalloutContentProps {
  link: string,
  handleClose: Function,
  i18n: any,
  classes: any,
}

class unstyleCalloutContent extends React.PureComponent<ICalloutContentProps> {
  render() {
    const ContentMessage = this.props.i18n.getString(_TL_("This feature isn't available in the new version yet."));
    const LinkMessage = this.props.i18n.getString(_TL_('Go to this feature in previous Microsoft Advertising.'));
    const { classes } = this.props;
    const clickAction = (e: any) => {
      this.props.handleClose(e);
      window.open(this.props.link);
    }

    return (
      <React.Fragment>
        <div className={classNames([classes.message, 'bingads-webui-campaign-react-fallback-callout-message'])}>
          {ContentMessage}
        </div>
        <div>
          <Button
            className={classNames([classes.link, 'bingads-webui-campaign-react-fallback-callout-link'])}
            onClick={clickAction}
            btnStyle="link"
          >
            <Glyphicon glyph="ba-OpenInNewWindow" />
            {LinkMessage}
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

export const CalloutContent = withI18nConsumer(withDefaultStyles(unstyleCalloutContent, calloutContentStyle));

interface IMiniCalloutProps {
  innerText: string,
  href: string,
  bannerType: TargetComponent,
  i18n: any,
  classes: any,
  handleClick: any,
}

interface IMiniCalloutState {
  showCallout: boolean,
}

class unstyleMiniCallout extends React.PureComponent<IMiniCalloutProps, IMiniCalloutState> {
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    handleClick: () => {},
  };

  constructor(props: IMiniCalloutProps) {
    super(props);
    this.state = {
      showCallout: false,
    };
  }

  handleCalloutClose = () => {
    this.setState({ showCallout: false });
  }

  handleClick = (event: any) => {
    // eslint-disable-next-line no-mixed-operators
    if (event.type === 'click' || event.type === 'keydown' && [13, 32].indexOf(event.which) >= 0) {
      this.setState(state => ({
        showCallout: !state.showCallout,
      }));
      if (this.props.bannerType === TargetComponent.TopBanner) {
        this.props.handleClick?.();
      }
    }
  }

  render() {
    const { classes, innerText, href, i18n, bannerType } = this.props;
    return (
      <Callout
        classes={{ calloutTargetContainer: classes.calloutTargetContainer, calloutCloseButton: classes.calloutCloseButton }}
        popoverId={bannerType === TargetComponent.TopBanner ? 'top-banner-callout' : 'floating-banner-callout'}
        closeButton
        popoverClassName={classes.popover}
        title={<span className={classNames([classes.title, 'bingads-webui-campaign-react-fallback-callout-title'])}>{innerText}</span>}
        content={<CalloutContent handleClose={this.handleCalloutClose} link={href} i18n={i18n} />}
        show={this.state.showCallout}
        onClose={this.handleCalloutClose}
        focusLockContent
      >
        { // According to designer, top banner uses button and floating banner uses hyperlink for action
          bannerType === TargetComponent.TopBanner ?
          <div className={classNames('notification-center-top-banner-action', classes.button)} onClick={this.handleClick} onKeyDown={this.handleClick} role="button" tabIndex={0}>
            <span className={classes.innerText} title={innerText}>{innerText}</span>
            <Glyphicon className={classes.openIcon} glyph="ba-OpenInNewWindow" />
          </div> :
          // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-static-element-interactions
          <a onClick={this.handleClick} onKeyDown={this.handleClick} tabIndex={0}>
            <span className={classes.innerTextInLink}>{innerText}</span>
            <Glyphicon className={classes.openIconInLink} glyph="ba-OpenInNewWindow" />
          </a>
        }
      </Callout>
    );
  }
}

export const MiniCallout = withI18nConsumer(withDefaultStyles(unstyleMiniCallout, miniCalloutStyle));
